var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { C } from '#integrations';
import { AlertTriangleIcon, XCloseIcon } from '../icons';
import { Tooltip, useTooltip } from '../Tooltip';
import { TagTestIdFactory } from './interactions';
import styles from './Tag.module.css';
export const Tag = ({ 'data-testid': testid, disabled, hasError, isFocused, onClear, onClick, onKeyDown, tabIndex, tooltipContent, tooltipPosition, value, }) => {
    _react_refresh_temp_2();
    const { isTooltipActive, refs, tooltipProps, triggerProps } = useTooltip({
        placement: tooltipPosition,
    });
    return (_jsxs("div", { className: C(styles.Container, hasError && styles.ContainerNegative, disabled && styles.ContainerDisabled, isFocused && styles.ContainerFocused), "data-testid": TagTestIdFactory.getTagTestId(testid), onClick: onClick, onKeyDown: onKeyDown, role: "option", tabIndex: tabIndex || disabled ? -1 : 0, ...(hasError && { 'data-error': true }), ...(Boolean(tooltipContent) && triggerProps), children: [hasError && _jsx(AlertTriangleIcon, { size: "small" }), _jsx("span", { className: styles.Value, title: value, children: value }), _jsx("span", { "aria-hidden": "true", className: C(styles.Button, disabled && styles.ButtonDisabled), "data-testid": TagTestIdFactory.getTagCloseButtonTestId(testid), onClick: onClear, children: _jsx(XCloseIcon, { size: "small" }) }), isTooltipActive &&
                tooltipContent &&
                refs.reference.current !== null && (_jsx(Tooltip, { contents: tooltipContent, tooltipProps: tooltipProps }))] }));
};
_react_refresh_temp_1 = Tag;
$RefreshReg$(_react_refresh_temp_1, "Tag");
_react_refresh_temp_2(Tag, "CtBUYTKeipBgRXuu/718U77+ITc=", false, () => [useTooltip]);
